import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-task-summary-dialog',
  templateUrl: './task-summary-dialog.component.html',
  styleUrls: ['./task-summary-dialog.component.css']
})
export class TaskSummaryDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
